// directives.module.ts
import { NgModule } from '@angular/core';
import { AriaLabelDirective } from './directives/aria-label.directive';
import { FocusDirective } from './directives/focus.directive';
import { ClickDirective } from './directives/click.directive';
import { MultiSelectAnnouncement } from './directives/multi-select-announcement.directive';
import { OnlyNumbersDirective, OnlyAlphabetDirective, OnlyAlphabetWithSpaceDirective, OnlyMobileNumberDirective } from './directives/input-restrictions.directive';
import { CustomTooltipDirective } from './directives/custom-tooltip.directives';

@NgModule({
  declarations: [AriaLabelDirective, FocusDirective, ClickDirective, MultiSelectAnnouncement, OnlyNumbersDirective, OnlyAlphabetDirective, OnlyAlphabetWithSpaceDirective, OnlyMobileNumberDirective, CustomTooltipDirective],
  exports: [AriaLabelDirective, FocusDirective, ClickDirective, MultiSelectAnnouncement, OnlyNumbersDirective, OnlyAlphabetDirective, OnlyAlphabetWithSpaceDirective, OnlyMobileNumberDirective, CustomTooltipDirective]
})
export class DirectivesModule {}
